import { Box } from '@mui/material';
import { useEffect, useState } from 'react';

import { checkUserIsConnectedOnStart } from '@/domain/auth/actions/check-user-connected-on-start.action';
import {
  Category,
  ImpactCo2Answer,
} from '@/domain/impact-co2/entities/question.entity';
import { getImpactEnvQuestions } from '@/domain/impact-env/actions/get-impact-env-questions.action';
import { getImpactEnvResponses } from '@/domain/impact-env/actions/get-impact-env-responses.action';
import { EnvTopic } from '@/domain/impact-env/entities/question.entity';
import { getProjectFestival } from '@/domain/project-festival/actions/get-project-festival.action';
import { getProjectsFestival } from '@/domain/project-festival/actions/get-projects-festival.action';
import { selectProjectFestivalItems } from '@/domain/project-festival/project-festival.selectors';
import { selectCurrentProjectVenue } from '@/domain/project-venue/project-venue.selectors';
import { useAppDispatch, useAppSelector } from '@/ui/hook/store';
import { EquipmentForm } from '@/ui/pages/app/components/quiz-panel/co2/components/forms/EquipmentForm';
import { MobilityForm } from '@/ui/pages/app/components/quiz-panel/co2/components/forms/MobilityForm';
import { ImpactForm } from '@/ui/pages/app/components/quiz-panel/co2/ImpactForm';
import { EnvQuiz } from '@/ui/pages/app/components/quiz-panel/env/EnvQuiz';
import { ImpactQuestionContext } from '@/ui/pages/app/components/quiz-panel/ImpactQuestionContext';
import { envVenueStructureQuizLayout } from '@/ui/pages/app/project/venue/structure/utils/venue-stucture-env-quiz-layout';

export function DevImpactQuestionsVenue() {
  const dispatch = useAppDispatch();

  const [projectId, setProjectId] = useState<number>(-1);

  useEffect(() => {
    const runAsync = async () => {
      await dispatch(checkUserIsConnectedOnStart());
      await dispatch(getProjectsFestival());
    };
    runAsync();
  }, [dispatch]);

  const projects = useAppSelector(selectProjectFestivalItems);

  useEffect(() => {
    if (projects.length > 0) {
      setProjectId(projects[0].id);
    }
  }, [projects]);

  useEffect(() => {
    if (projectId !== -1) {
      dispatch(getProjectFestival(projectId));
      dispatch(getImpactEnvQuestions());
      dispatch(getImpactEnvResponses({ projectId }));
    }
  }, [projectId, dispatch]);

  return (
    <div>
      <h2>co2 - impact form</h2>
      <Co2QuizVenue />
      <h2>co2 - form</h2>
      <Co2FormVenue />
      <h2>env</h2>
      <EnvForm />
    </div>
  );
}

function Co2QuizVenue() {
  const sector = 'SITE';
  const categories: Category[] = ['ENERGY', 'EQUIPMENT'];

  const project = useAppSelector(selectCurrentProjectVenue);
  // const project = { id: 239 };

  if (!project) {
    return null;
  }
  return (
    <Box sx={{ border: '2px dashed #A23344', px: 1 }}>
      <ImpactQuestionContext.Provider
        value={{ panelOpen: true, hideCompleted: false }}
      >
        <>
          {categories.map((category) => (
            <ImpactForm
              key={category}
              projectId={project.id}
              sector={sector}
              category={category}
            />
          ))}
        </>
      </ImpactQuestionContext.Provider>
    </Box>
  );
}

function Co2FormVenue() {
  const sector = 'SITE';
  const onSubmit = (answer: ImpactCo2Answer) => {
    console.log(answer);
    // dispatch(submitImpactCo2Answer({ answer, projectId, submitMode: 'create' }));
  };

  const onEdit = (answer: ImpactCo2Answer) => {
    console.log(answer);
    // dispatch(submitImpactCo2Answer({ answer, projectId, submitMode: 'edit' }));
  };

  const onDelete = (answer: ImpactCo2Answer) => {
    console.log(answer);
    // dispatch(deleteImpactCo2Answer({ answer: answer, projectId }));
  };

  return (
    <Box sx={{ border: '2px dashed #42CC54', px: 1 }}>
      <ImpactQuestionContext.Provider
        value={{ panelOpen: true, hideCompleted: false }}
      >
        <EquipmentForm
          sector={sector}
          onDelete={onDelete}
          onSubmit={onSubmit}
          onEdit={onEdit}
        />
        <MobilityForm
          sector={sector}
          onDelete={onDelete}
          onSubmit={onSubmit}
          onEdit={onEdit}
        />
      </ImpactQuestionContext.Provider>
    </Box>
  );
}

export function EnvForm() {
  return (
    <Box sx={{ border: '2px dashed #423CC4', px: 1 }}>
      <ImpactQuestionContext.Provider
        value={{ panelOpen: true, hideCompleted: false }}
      >
        <EnvQuiz
          sector="SITE"
          topic={EnvTopic.PUBLIC_ENGAGEMENT}
          envQuizLayout={envVenueStructureQuizLayout}
        />
      </ImpactQuestionContext.Provider>
    </Box>
  );
}
